import { PurchaseType } from "src/app/shared/models/app-models";

export enum KcRole {
    PURCHASE_CREATE_OWNER = 'PURCHASE_CREATE_OWNER',
    BASIC_READ_ALL = 'BASIC_READ_ALL',
    BASIC_UPDATE_ALL = 'BASIC_UPDATE_ALL',
    AOR_READ_ALL = 'AOR_READ_ALL',
    AOR_UPDATE_ALL = 'AOR_UPDATE_ALL',
    WOC_READ_ALL = 'WOC_READ_ALL',
    WOC_UPDATE_ALL = 'WOC_UPDATE_ALL',
    ATTACHMENT_READ_ALL = 'ATTACHMENT_READ_ALL',
    ATTACHMENT_UPDATE_ALL = 'ATTACHMENT_UPDATE_ALL',
    DEADLINE_READ_ALL = 'DEADLINE_READ_ALL',
    DEADLINE_UPDATE_ALL = 'DEADLINE_UPDATE_ALL',
    TAGGING_READ_ALL = 'TAGGING_READ_ALL',    
    TAGGING_UPDATE_ALL = 'TAGGING_UPDATE_ALL',
    SOW_READ_ALL = 'SOW_READ_ALL',    
    SOW_UPDATE_ALL = 'SOW_UPDATE_ALL',
    DOTP_READ_ALL = 'DOTP_READ_ALL',    
    DOTP_UPDATE_ALL = 'DOTP_UPDATE_ALL',
    TVALIDITY_READ_ALL = 'TVALIDITY_READ_ALL',    
    TVALIDITY_UPDATE_ALL = 'TVALIDITY_UPDATE_ALL',
    PEREPORT_READ_ALL = 'PEREPORT_READ_ALL',
}


export enum DocRole {
    RO = 'RO',
    CREATOR = 'CREATOR'
}

export const KeycloakPurchasePrefixMap: Record<string, PurchaseType> = {
    'RFQ': PurchaseType.RFQ,
    'SVP': PurchaseType.SMALL,
    'DC': PurchaseType.DC,
    'TNDR': PurchaseType.TENDER,
    'CCCP': PurchaseType.CORPORATE_CARD,
    'PCPO': PurchaseType.PERMISSIBLE_COVERING
};
export const RouteToPurchaseTypeMap: Record<string, PurchaseType> = {
    'rfq': PurchaseType.RFQ,
    'dc': PurchaseType.DC,
    'tender': PurchaseType.TENDER,
    'corporatecard': PurchaseType.CORPORATE_CARD,
    'permissiblecoveringpurchaseorder': PurchaseType.PERMISSIBLE_COVERING
};


export enum OtherPermissionModule {
    REPORTS = 'Reports'
}

export const KeycloakOtherModulePrefixMap: Record<string, OtherPermissionModule> = {
    'REPORTS': OtherPermissionModule['REPORTS'],
}